import { defineMessages } from 'react-intl-next';
export var userTypeMessages = defineMessages({
  userDefaultdisplayNameValue: {
    id: 'linkDataSource.render-type.user.default.display.name',
    description: 'Text to display for the user type when no display value is provided',
    defaultMessage: 'Unassigned'
  }
});